import React from 'react';
import { DependentInfoContent } from './DependentInfoContent';
import styled from '@emotion/styled';
import { token } from '@ferreri/prever-component-lib';
import { SubscriptionDependentRuleType } from './rules.types';
import { DependentInfoItem } from './DependentInfoItem';

type SubscriptionRulesProps = {
  subscriptionRules: SubscriptionDependentRuleType[];
};

export const SubscriptionRules = (props: SubscriptionRulesProps) => {
  return (
    <SubscriptionWrapper>
      {!props.subscriptionRules.length && (
        <DependentInfoItem label="Mensalidade" />
      )}
      {props.subscriptionRules?.map((subscription) => {
        const {
          id,
          absolute_price,
          relative_price,
          min_age,
          max_age,
          marital_status,
        } = subscription;

        const showAbsolute = absolute_price > 0;
        const showRelative = relative_price > 0;

        return (
          <DependentInfoContent
            key={id}
            id={id}
            showAbsolute={showAbsolute}
            showRelative={showRelative}
            absolute_price={absolute_price}
            relative_price={relative_price}
            max_age={max_age}
            min_age={min_age}
            marital_status={marital_status}
          />
        );
      })}
    </SubscriptionWrapper>
  );
};

const SubscriptionWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${token.spacing.spacingXxSmall};
`;
